import PropTypes from 'prop-types';
import React from 'react';

export default function Form({ children, ...props }) {
	return (
		<form noValidate tw='w-full' {...props}>
			{children}
		</form>
	);
}

Form.propTypes = {
	id: PropTypes.string.isRequired
};
